// extracted by mini-css-extract-plugin
export default {"statusWrapper":"PaymentStatusChip_statusWrapper__3dY7D","statusChipText":"PaymentStatusChip_statusChipText__KU1eG"};